import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useNavigateWithScrollMemory } from '../../../../hooks/useNavigateWithScrollMemory';
import UserReviewItem from './UserReviewItem';
import theme from '../../../../theme';

const MAX_DISPLAY_COUNT = 10;

const UserReviewSection = ({ reviews, totalCount, albumSource, sourceId }) => {
  const location = useLocation();
  const navigateWithScrollMemory = useNavigateWithScrollMemory();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {/* 헤더 */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          pb: 1,
          borderBottom: `1px solid ${theme.palette.grey.line}`,
        }}
      >
        <Typography
          fontSize={{ xs: 16, md: 18 }}
          fontWeight={'bold'}
          color={theme.palette.black[9]}
        >
          회원 리뷰 ({totalCount})
        </Typography>
        {totalCount > MAX_DISPLAY_COUNT && (
          <Typography
            component="button"
            type="button"
            onClick={() => navigateWithScrollMemory(`${location.pathname}/user-reviews`)}
            sx={{
              appearance: 'none',
              border: 0,
              background: 'transparent',
              p: 0,
              color: theme.palette.black[4],
              cursor: 'pointer',
              fontSize: { xs: 13, md: 14 },
              fontWeight: 400,
              lineHeight: 1.5,
              whiteSpace: 'nowrap',
            }}
          >
            더보기
          </Typography>
        )}
      </Box>

      {/* 리뷰 리스트 + 더보기 버튼 */}
      {reviews.length > 0 && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 0, md: 2.25 },
          }}
        >
          <Box sx={{ width: '100%' }}>
            {reviews.slice(0, MAX_DISPLAY_COUNT).map((review) => (
              <UserReviewItem
                key={review.id}
                review={review}
                albumSource={albumSource}
                sourceId={sourceId}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default UserReviewSection;
